import type { Product } from '../../cpn-components/CpnProductCard/types'
import type { Img } from '../../types/props'

export type SearchPageType = 'products' | 'blogs' | 'pages'

export type SortKey = {
  id: string
  value: string
  label: string
}

export interface SearchPageProps extends React.HTMLAttributes<HTMLDivElement> {
  searchResult: {
    [key in SearchPageTabType]: any
  }
  searchResultCount: {
    [key in SearchPageTabType]: number
  }
  loading?: boolean
  shopNowLoadingProductId?: string
  searchValue: string
  data: any
  buildProps?: {
    products: any[]
  }
  onChangeTab?: (tabType: SearchPageTabType) => void
  onSecondaryButton?: (product: Product) => void
  onPrimaryButton?: (product: Product) => void
  // loadMore?: (type: SearchPageType) => void
  onChangeSort?: (tabType: SearchPageType, sortKey: { value: string; label: string }) => void
}

export interface SearchProductItemProps {
  searchValue?: string
  product: any
  variantData?: any
  shopNowLoadingProductId?: string
  onSecondaryButton?: () => void
  onPrimaryButton?: () => void
}

export interface SearchBlogItemProps {
  searchValue: string
  blog: any
}

export interface SearchPageItemProps {
  searchValue: string
  page: any
}

export enum SearchPageTabType {
  PRODUCTS = 'products',
  BLOGS = 'blogs',
  PAGES = 'pages',
}

export interface SearchRecommendProductsProps {
  products: any[]
  title: string
  shopNowLoadingProductId?: string
  buildProps?: {
    products: any[]
  }
  onSecondaryButton?: () => void
  onPrimaryButton?: () => void
}

export const IPC_SEARCH_PAGE = 'ipc-search-page'
